import { render, staticRenderFns } from "./BCKeyAssignmentBLEKey.vue?vue&type=template&id=5db4cb61&scoped=true"
import script from "./BCKeyAssignmentBLEKey.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentBLEKey.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentBLEKey.vue?vue&type=style&index=0&id=5db4cb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db4cb61",
  null
  
)

export default component.exports